import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { alertIcon } from '@/assets';
import LoadErrorStyles from './LoadError.style';

const LoadError = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleNavigateDashboard = () => {
    navigate('/dashboard');
  };

  return (
    <Box className={LoadErrorStyles.wrapper}>
      <img className={LoadErrorStyles.image} src={alertIcon} alt="alert icon" />
      <Typography className={LoadErrorStyles.header} variant="h4">
        {t('ldErrTitle')}
      </Typography>
      <Typography variant="body2">{t('ldErrDesc')}</Typography>
      <Button
        className={LoadErrorStyles.actionButton}
        variant="contained"
        onClick={handleNavigateDashboard}
      >
        {t('ldErrGoToDashboard')}
      </Button>
    </Box>
  );
};

export default LoadError;
